import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DiagnosticFilter } from '../model/diagnostic-filter';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class DiagnosticService {

  constructor(private http: HttpClient,
    private dataService: DataService) { }

  private readonly getDiagnosticsFilterEndPoint: string = '/Diagnostic/getDiagnosticsFilter/';
  
  async getDiagnosticsFilter(): Promise<DiagnosticFilter[]> {
    return await this.dataService.get<DiagnosticFilter[]>
      (this.getDiagnosticsFilterEndPoint).toPromise();
  }
}
